import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "./assets/style/main.scss";
import Vuelidate from "vuelidate";
import * as VueSpinnersCss from "vue-spinners-css";
import loaderComponent from "./components/Loader/loader.component.vue";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

Vue.component("loaderComponent", loaderComponent);
Vue.use(Vuelidate);
Vue.use(VueSpinnersCss);
Vue.use(VueSweetalert2);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: function (h) {
    return h(App);
  },
}).$mount("#app");
